export const Meta = (props: Props) => {
  return (
    <>
      <title>{props.title}</title>

      <meta name="description" content={props.description} />

      <meta property="og:url" content={props.url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" content={props.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content={props.domain} />
      <meta property="twitter:url" content={props.url} />
      <meta name="twitter:title" content={props.title} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={props.image} />
    </>
  )
}

Meta.withDefaults = (defaults: Props) => {
  return (overrides?: Partial<Omit<Props, "url">>) => {
    const title = overrides?.title ? `${overrides.title} - ${defaults.title}` : defaults.title
    const url = overrides?.path ? buildAbsoluteUrl(overrides.path, defaults.url) : defaults.url

    return <Meta {...defaults} {...overrides} title={title} url={url} />
  }
}

const buildAbsoluteUrl = (path: string, baseUrl: string) => {
  try {
    return new URL(path, baseUrl).href
  } catch {
    return baseUrl
  }
}

type Props = {
  title: string
  description: string
  image: string
  url: string
  domain: string
  path?: string
}
